module.exports = __webpack_public_path__ + "img/SURVEY_ANXIETYSCALE_SM.895057c7.png";